module.exports = __webpack_public_path__ + "static/media/home_subMenu.aff22c36.svg";